import React, { Component, useState } from "react";
import InfoIcon from "./icons/infoIcon.svg";
import "./index.scss";

const Message = ({ msg, color = "black" }) => {
  return (
    <div className="auth-message-container">
      {msg && <img src={InfoIcon} />}
      {msg && <p style={{ color: color }}>{msg}</p>}
    </div>
  );
};

export default Message;
